import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { ADULT_CATEGORIES, FAMILY_CATEGORIES } from "@/lib/ageCategories";
import { toast } from "sonner";
import { X, Loader2, Sparkles } from "lucide-react";

const DELAY_MS = 45000;
const DONE_KEY = "interest_lead_done";

export function InterestPopup() {
  const { accessToken, userToken } = useApp();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [cats, setCats] = useState([]);
  const [saving, setSaving] = useState(false);
  const [optin, setOptin] = useState(true);

  useEffect(() => {
    if (!accessToken || userToken || localStorage.getItem(DONE_KEY)) return;
    const t = setTimeout(() => setOpen(true), DELAY_MS);
    return () => clearTimeout(t);
  }, [accessToken, userToken]);

  if (!open) return null;

  const toggle = (id) => setCats((c) => (c.includes(id) ? c.filter((x) => x !== id) : [...c, id]));
  const dismiss = () => { localStorage.setItem(DONE_KEY, "1"); setOpen(false); };

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (!phone.trim().startsWith("+")) { toast.error("Incluye el prefijo del móvil, p. ej. +34"); setSaving(false); return; }
      await api.post("/leads", { email, phone, interest_categories: cats });
      localStorage.setItem(DONE_KEY, "1");
      toast.success("¡Gracias! Te avisaremos de lo que te interese.");
      setOpen(false);
    } catch (err) {
      toast.error("No se pudo guardar, inténtalo de nuevo.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="interest-popup" className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md p-6 sm:p-7 relative animate-in slide-in-from-bottom-4">
        <button data-testid="interest-popup-close" onClick={dismiss} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"><X size={20} /></button>
        <div className="flex items-center gap-2 mb-1"><Sparkles size={20} className="text-[#F68D2E]" /><h3 className="text-xl font-black brand-navy">¿Qué te interesa?</h3></div>
        <p className="text-sm text-slate-500 mb-4">Dinos para qué perfil de edades te interesan las actividades y te avisaremos de las que encajen contigo.</p>
        <form onSubmit={submit} className="space-y-4">
          <div className="flex flex-wrap gap-2 items-center">
            {ADULT_CATEGORIES.map((c) => (
              <button type="button" key={c.id} data-testid={`interest-popup-${c.id}`} onClick={() => toggle(c.id)} className={`rounded-full px-3 py-1.5 text-sm font-bold border-2 transition-colors ${cats.includes(c.id) ? "border-[#003284] " + c.cls : "border-slate-200 text-slate-500"}`}>{c.label} <span className="opacity-60 font-semibold">{c.range}</span></button>
            ))}
            <span className="w-full text-[11px] font-bold uppercase tracking-wide text-[#FF7F27] mt-1">Familiares</span>
            {FAMILY_CATEGORIES.map((c) => (
              <button type="button" key={c.id} data-testid={`interest-popup-${c.id}`} onClick={() => toggle(c.id)} className={`rounded-full px-3 py-1.5 text-sm font-bold border-2 transition-colors ${cats.includes(c.id) ? "border-[#003284] " + c.cls : "border-slate-200 text-slate-500"}`}>{c.label} <span className="opacity-60 font-semibold">{c.range}</span></button>
            ))}
          </div>
          <input data-testid="interest-popup-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Tu correo electrónico" className="w-full rounded-xl border-2 border-slate-200 focus:border-[#003284] outline-none px-4 py-2.5 transition-colors" />
          <input data-testid="interest-popup-phone" type="tel" required value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Móvil con WhatsApp (+34 600 000 000)" className="w-full rounded-xl border-2 border-slate-200 focus:border-[#003284] outline-none px-4 py-2.5 transition-colors" />
          <label className="flex items-start gap-2.5 cursor-pointer">
            <input data-testid="interest-popup-optin" type="checkbox" className="w-4 h-4 mt-0.5 accent-[#25D366]" checked={optin} onChange={(e) => setOptin(e.target.checked)} />
            <span className="text-xs text-slate-500 leading-relaxed">Acepto recibir avisos de nuevas actividades por WhatsApp.</span>
          </label>
          <button data-testid="interest-popup-submit" disabled={saving} className="w-full bg-brand-orange text-white font-bold rounded-full py-3 hover:bg-[#DE7A1C] disabled:opacity-50 transition-colors flex items-center justify-center gap-2">{saving ? <Loader2 className="animate-spin" size={18} /> : "Avísame"}</button>
        </form>
      </div>
    </div>
  );
}
